var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcavator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 33C35.08 33 36 33.92 36 35C36 36.08 35.08 37 34 37H10C8.92001 37 8.00001 36.08 8.00001 35C8.00001 33.92 8.92001 33 10 33H34ZM34 30H10C7.26001 30 5.00001 32.26 5.00001 35C5.00001 37.74 7.26001 40 10 40H34C36.76 40 39 37.76 39 35C39 32.24 36.76 30 34 30ZM39 18H33V10H23L17 18V28H41L39 18ZM20.08 18L24 13H29V18H20.08ZM16.52 2.82L6.52001 0L1.00001 19.66C0.32001 22.22 1.82001 24.88 4.40001 25.6L6.72001 26.24L13.3 20.58L5.54001 18.42L9.30001 4.92L14.88 6.48C16 7.06 18.42 8.68 19.94 10.74L22 8H22.88C20.36 4.82 16.7 2.92 16.52 2.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcavator);
export default __webpack_public_path__ + "static/media/excavator.7bb1e4ae8e4f986d627d4f5435ec4e46.svg";
export { ForwardRef as ReactComponent };